import { render, staticRenderFns } from "./member-carrousel-box.vue?vue&type=template&id=4cd82c4a"
import script from "./member-carrousel-box.vue?vue&type=script&lang=js"
export * from "./member-carrousel-box.vue?vue&type=script&lang=js"
import style0 from "./member-carrousel-box.vue?vue&type=style&index=0&id=4cd82c4a&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports